export const ComponentOverrides = {};



// WEBPACK FOOTER //
// ./src/model-registry/overrides/component-overrides.js